import styled from 'styled-components';

export const Container = styled.div`
    padding-top: 48px;   
    width: 100%;
    display: flex;
    justify-content: flex-end;

    .status {
        display: flex;
        justify-content: space-between;
        width: 100%;
        max-width: 480px;
        position: relative;
        
        @media (max-width: 768px) {
            max-width: 100%;
            padding: 0 16px;
        }
        
        @media (max-width: 480px) {
            padding: 0 8px;
        }
        
        .status-square {
            width: 55px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 16px;
            flex-shrink: 0;
            
            @media (max-width: 480px) {
                width: 45px;
                gap: 12px;
            }
            
            p {
                font-size: 14px;
                font-weight: 400;
                white-space: nowrap;
                text-align: center;
                /* etapa inativa: legível nos dois temas (claro no dark, escuro no light) */
                color: ${({ theme }) => theme.colors.interfaceText400};

                @media (max-width: 480px) {
                    font-size: 12px;
                }

                /* etapa atual/concluída: texto forte (quase branco no dark) */
                &.on {
                    font-weight: 500;
                    color: ${({ theme }) => theme.colors.interfaceText500};
                }
            }
            &.first {
                white-space: nowrap;
                p {
                    font-weight: 500;
                    color: ${({ theme }) => theme.colors.interfaceText500};
                }
            }
        }
        .square {
            width: 48px;
            height: 48px;
            border-radius: 8px;
            background: ${({ theme }) => theme.colors.interfacePure100};   
            z-index: 5;
            display: flex;
            align-items: center;
            justify-content: center;
            
            @media (max-width: 480px) {
                width: 40px;
                height: 40px;
            }
            
            svg {
                width: 24px;
                height: 24px;
                
                @media (max-width: 480px) {
                    width: 20px;
                    height: 20px;
                }
                
                path[fill] {
                    fill: ${({ theme }) => theme.colors.interfaceText300};
                }
                [stroke] {
                    stroke: ${({ theme }) => theme.colors.interfaceText300};
                }
            }
        }
        .active {
            background: ${({ theme }) => theme.colors.primaryRed400};
            svg {
                path[fill] {
                    fill: ${({ theme }) => theme.colors.pureWhite};
                }
                [stroke] {
                    stroke: ${({ theme }) => theme.colors.pureWhite};
                }
            }
        }
    }
`;

export const Hr1 = styled.hr`
    width: 100%;
    max-width: 460px;
    height: 1px;
    border: none;
    background: ${({ theme }) => theme.colors.interfaceText200};
    position: absolute;
    top: 25px;
    left: 10px;
    transform: translateY(-50%);
    z-index: 1;
    
    @media (max-width: 768px) {
        max-width: calc(100% - 20px);
        left: 10px;
    }
    
    @media (max-width: 480px) {
        max-width: calc(100% - 16px);
        left: 8px;
        top: 20px;
    }
    
    &.first {
        background: linear-gradient(to right,  ${({ theme }) => theme.colors.primaryRed400} 0%, ${({ theme }) => theme.colors.primaryRed400} 20%, ${({ theme }) => theme.colors.interfaceText200} 20%, ${({ theme }) => theme.colors.interfaceText200} 100%);
    }
    &.second {
        background: linear-gradient(to right,  ${({ theme }) => theme.colors.primaryRed400} 0%,${({ theme }) => theme.colors.primaryRed400} 50%, ${({ theme }) => theme.colors.interfaceText200} 50%, ${({ theme }) => theme.colors.interfaceText200} 100%);
    }
    &.third {
        background: linear-gradient(to right,  ${({ theme }) => theme.colors.primaryRed400} 0%,${({ theme }) => theme.colors.primaryRed400} 75%, ${({ theme }) => theme.colors.interfaceText200} 75%, ${({ theme }) => theme.colors.interfaceText200} 100%);
    }
    &.fourth {
        background: linear-gradient(to right,  ${({ theme }) => theme.colors.primaryRed400} 0%,${({ theme }) => theme.colors.primaryRed400} 100%, ${({ theme }) => theme.colors.interfaceText200} 100%, ${({ theme }) => theme.colors.interfaceText200} 100%);
    }
`